import React from "react";

interface UserInfoItemProps {
  icon?: React.ReactNode;
  label: string;
  value: string | undefined | null;
  bold: boolean;
}

export const UserInfoItem = ({ icon, label, value, bold = false }: UserInfoItemProps) => (
  <div className="flex items-center justify-between gap-5">
    <div className="flex flex-col justify-between items-start gap-0">
      <p className="text-[15px] font-light leading-[18.9px] underline underline-offset-auto decoration-transparent text-gray-375">
        {label}
      </p>
      <p className={bold ? "font-medium" : ""}>{value}</p>
    </div>
    {icon && (
      <div className="text-2xl text-ominimo-400 bg-ominimo-400-transparent rounded-[2px] p-[14px]">
        {icon}
      </div>
    )}
  </div>
);
